import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './PropertyManagement.css';

const LeadAcquisition: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const savedVolume = localStorage.getItem('videoVolume');
    if (savedVolume !== null) video.volume = parseFloat(savedVolume);

    const handleVolumeChange = () => {
      localStorage.setItem('videoVolume', String(video.volume));
    };
    video.addEventListener('volumechange', handleVolumeChange);
    return () => video.removeEventListener('volumechange', handleVolumeChange);
  }, []);

  return (
    <div className="re-page">
      <div className="re-bg">
        <div className="re-nebula re-nebula-1" />
        <div className="re-nebula re-nebula-2" />
        <div className="re-nebula re-nebula-3" />
      </div>

      <div className={`re-content ${isVisible ? 'visible' : ''}`}>
        <nav className="re-nav">
          <Link to="/property-management" className="re-back">
            ← Back to Property Management
          </Link>
        </nav>

        <section className="re-hero">
          <h1 className="re-headline">Demo: Lead acquisition</h1>
        </section>

        <section className="re-case-study">
          <div className="re-video-wrapper">
            <video
              ref={videoRef}
              className="re-video"
              src="/videos/lead_acquisition_trailer.mp4"
              poster="/videos/lead_acquisition_poster.jpg"
              autoPlay
              loop
              muted
              playsInline
              controls
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <p className="re-demo-desc">An AI leasing assistant that answers lead questions the moment they come in and books tours straight to your calendar.</p>
        </section>
      </div>
    </div>
  );
};

export default LeadAcquisition;
